<template>

    <div v-if="fetcher.initialized">

        <h2>Inställningar för anställda</h2>

        <div class="row">
            <div class="col-md-12">

                <div class="custom-form-section">

                    <h4>Delbetalning</h4>

                    <input-check-radio
                        type="radio"
                        name="employee_part_payment"
                        v-model="company.employee_part_payment_type"
                        :options="[
                            {value: 'none', label: 'Ingen delbetalning (företaget betalar allt)'},
                            {value: 'salary', label: 'Alltid via löneavdrag'},
                            {value: 'allowance_or_salary', label: 'Den anställde väljer friskvårdsbidrag eller löneavdrag'},
                        ]"
                    />

                    <input-text
                        type="number"
                        name="employee_part_payment_amount"
                        label="Belopp"
                        v-model="company.employee_part_payment_amount"
                        addon="kr inkl moms"
                        form-group-class="w-50"
                        errorMessage="Ett belopp behövs om den anställde ska delbetala"
                        v-if="company.employee_part_payment_type !== 'none'"
                    />

                </div>

            </div>

            <div class="col-md-12">

                <div class="custom-form-section">

                    <h4>Notiser</h4>

                    <input-check-radio
                        type="radio"
                        name="employee_notice_method"
                        v-model="company.employee_notice_method"
                        :options="[
                            {value: 'phone', label: 'SMS'},
                            {value: 'email_work', label: 'E-post arbete (om fältet är valt nedan)'},
                            {value: 'email_private', label: 'E-post privat (om fältet är valt nedan)'},
                        ]"
                    />

                </div>

            </div>

        </div>

        <div class="row mb-8">
            <div class="col-md-12">
                <div class="custom-form-section mb-0 h-100">

                    <h4>Visa fliken behandlingar i massörsportalen.</h4>
                    <input-check-radio
                        type="checkbox"
                        name="company_portal_show_treatments"
                        v-model="company.company_portal_show_treatments"
                        :options="[
                            {value: true, label: 'Visa'},
                        ]"
                    />

                </div>
            </div>

            <div class="col-md-12">

                <div class="custom-form-section mb-0 h-100">

                    <h4>Text i webbapp</h4>
                    <input-text
                        type="text"
                        name="employee_description"
                        label="Text som visas under behandlingar, för att ange max antal behandlingar."
                        v-model="company.employee_description"
                    />

                </div>

            </div>
        </div>

        <div class="d-flex justify-content-end mb-8">
            <button class="btn btn-primary" @click="patcherPatch()" :disabled="patcher.submitted">
                <span class="spinner-border spinner-border-sm"></span>
                Spara
            </button>
        </div>

        <dynamic-fields
            :company="company"
            @refresh="fetcherFetch()"
        />

        <company-open-registration-settings
            :company="company"
        />

    </div>

</template>

<script>
import patcher from '../../../../shared/mixins/patcher'
import fetcher from '../../../../shared/mixins/fetcher'

import companyOpenRegistrationSettings from './employees-settings-open-registration'
import dynamicFields from './employees-settings-dynamic-fields'

export default {

    mixins: [
        patcher,
        fetcher
    ],

    components: {
        companyOpenRegistrationSettings,
        dynamicFields
    },

    props: {
        company_id: {
            required: true
        }
    },

    data () {
        return {
            company: null,
            fetcher: {
                autoFill: [
                    'company'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/companies/' + this.company_id + '/companySettingsTab'
        },
        patcherUrl () {
            return '/companies/' + this.company_id
        },
        patcherData () {
            return {
                employee_notice_method: this.company.employee_notice_method,
                employee_part_payment_type: this.company.employee_part_payment_type,
                employee_part_payment_amount: this.company.employee_part_payment_amount,
                employee_description: this.company.employee_description,
                company_portal_show_treatments: this.company.company_portal_show_treatments
            }
        }

    },

    methods: {

        patcherSuccess (data) {
            bus.$emit(
                'notify',
                'Inställningarna har sparats'
            )
        }
    }

}
</script>
